import Swiper from "swiper/bundle";

class SwiperBlock {
  
  constructor() {
    this.swipers = document.querySelectorAll(".js-swiper");
  }

  init() {
    this.setupSwiper();
  }

  /* eslint-disable */
  setupSwiper() {
    this.swipers.forEach((swiper, i) => {

        if ( swiper.querySelectorAll('.swiper-slide').length > 1 ) {

          swiper.classList.add("b-swiper--" + i);

          new Swiper(".b-swiper--" + i, {
            slidesPerView: 1.15,
            navigation: {
              nextEl: ".b-swiper--" + i + " .b-swiper__button-next",
              prevEl: ".b-swiper--" + i + " .b-swiper__button-prev",
            },
            breakpoints: {
              1024: {
                slidesPerView: 1,
                pagination: {
                  el: ".b-swiper--" + i + " .b-swiper__pagination",
                  type: "bullets",
                  clickable: true,
                },
              }
            }
          });

        } else {

          this.swipers.forEach((swiper) => {
            swiper.classList.add('no-swiper');
          });

        }

    });
  }
  /* eslint-enable */

}

export default SwiperBlock;
